import { useEntityList } from '@/shared/hooks/useEntityList';
import type { RootState } from '@/store';
import {
  deleteRole,
  fetchRoles,
  ROLES_DEFAULT_FILTERS,
  setFilters,
  setPage,
  setPerPage,
} from '../store/entitySlice';

const selectRoles = (state: RootState) => state.rolesEntity;

export const useRoles = () =>
  useEntityList({
    selector: selectRoles,
    fetchAction: fetchRoles,
    deleteAction: deleteRole,
    setPageAction: setPage,
    setPerPageAction: setPerPage,
    setFiltersAction: setFilters,
    defaultFilters: ROLES_DEFAULT_FILTERS,
    entityName: 'Role',
  });
